import { Checkbox, DataSource, ExcludableTextbox, Layout, NumberEditor, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTopDriverReport extends Layout {
    checkboxIncludeInactiveDrivers: Checkbox;
    checkboxPageBreakAfterDriverFleet: Checkbox;
    checkboxPageBreakAfterDriverManager: Checkbox;
    numbereditorDriversToPrint: NumberEditor;
    sourceTopDriver: DataSource;
    textboxDate: Textbox;
    textboxDateType: Textbox;
    textboxDriverFleet: ExcludableTextbox;
    textboxDriverManager: ExcludableTextbox;
    textboxDriverType: Textbox;
    textboxSecondarySort: Textbox;
    textboxSortBy: Textbox;
}
